angular
  .module("autorizzazioneIban.components", [])
  .component("autorizzazioneIban", {
    templateUrl: "ng/components/autorizzazioneIban/autorizzazioneIban.html",
    bindings: {
      id: "<",
      raccoltaInfo: "=",
      ibanIsOk: "&",
      ibanIsNotOk: "&",
      model: "=",
      autorizzazione: "&",
      digital: "=",
      isM14: "=",
      isArc: "=",
      isPostVendita: "=",
      richiestePostVendita: "=",
      isContratto: "<",
      showOtherBank: "=",
    },
    controllerAs: "autorizzazioneIbanCtrl",
    controller: function autorizzazioneIbanController(
      HttpService,
      FactoryObj,
      $typeDomainService,
      $financialApiService,
      $portalService,
      $rootScope,
      $transactionFactory
    ) {
      var self = this;

      self.$onInit = function () {
        self.raccoltaInfo = self.raccoltaInfo || null;
        self.placeholder = "";
        self.raccoltaInfo = {
          autorizzazioneSDD: {
            iban: "",
            newIban: "",
            banca: {
              nome: "",
            },
            ibanRadio: "",
            showOtherBank: false,
            otherBanks: "",
          },
        };

        self.loading = {
          listaIban: false,
        };
        self.dropdown = {
          listaIban: [],
          listaIbanObj: [],
          listaBanche: [],
        };

        self.isM12 = false;
        self.warnings = {};

        if (self.id === "varCoordBan" || !self.isPostVendita) {
          self.getIbanDropdown();
        }

        self.listBank();

        if (!self.isArc) {
          if (self.model.financialCustomer.metadata.autorizzazione) {
            self.raccoltaInfo.autorizzazioneSDD =
              self.model.financialCustomer.metadata.autorizzazione;
          }
        }

        if (self.isPostVendita && self.richiestePostVendita) {
          self.raccoltaInfo.autorizzazioneSDD.iban =
            self.richiestePostVendita.iban;
          self.raccoltaInfo.autorizzazioneSDD.showOtherBank =
            self.richiestePostVendita.showOtherBank;
          self.raccoltaInfo.autorizzazioneSDD.otherBanks =
            self.richiestePostVendita.otherBanks;
        }

        if (
          !self.isPostVendita &&
          getWizardMap(self.model.viewIndex) == "M12"
        ) {
          self.isM12 = true;
          self.ibanIsOk();
        }

        self.addIban = {
          selected: false,
        };

        if ($transactionFactory.get()) {
          self.addIban.selected = true;
          self.raccoltaInfo.autorizzazioneSDD.newIban =
            self.model.financialCustomer.metadata.autorizzazione.iban;
        }
      };

      self.$onChanges = function (changes) {
        console.log("changes :", changes);
        if (changes.isContratto.currentValue) {
          self.getIbanDropdown();
        }
      };

      self.getIbanDropdown = function () {
        self.loading.listaIban = true;
        self.isLoadingIbanList = true;

        if (self.digital) {
          var riUserGInput = self.digital
            ? self.model.financialCustomer.metadata.riUserG
            : self.richiestePostVendita.metadata.variazioneAnagrafica;

          $typeDomainService
            .getListIban(riUserGInput, true)
            .then(function (listAppNsilIban) {
              if (listAppNsilIban && listAppNsilIban.length > 0) {
                self.dropdown.listaIbanObj = listAppNsilIban;
                self.dropdown.listaIban = [];
                listAppNsilIban.forEach(function (el) {
                  self.dropdown.listaIban.push(el.iban);
                });
              } else if (listAppNsilIban && !listAppNsilIban.length) {
                self.addIban.selected = true;
              }
              self.isLoadingIbanList = false;
            })
            .catch(function (err) {
              console.log(err);
              self.dropdown.listaIban = [];
              self.isLoadingIbanList = false;
            })
            .finally(function () {
              console.log("getIbanDropdown finally");
              if (
                self.dropdown.listaIban &&
                self.dropdown.listaIban.length > 0
              ) {
                self.raccoltaInfo.autorizzazioneSDD.bySelect = true;
              } else {
                self.raccoltaInfo.autorizzazioneSDD.bySelect = false;
              }
              self.loading.listaIban = false;
            });
        } else {
          if (self.isPostVendita) {
            $typeDomainService
              .getListIbanPostVendita()
              .then(function (listAppNsilIban) {
                if (listAppNsilIban && listAppNsilIban.length > 0) {
                  self.dropdown.listaIbanObj = listAppNsilIban;
                  self.dropdown.listaIban = [];
                  listAppNsilIban.forEach(function (el) {
                    self.dropdown.listaIban.push(el.iban);
                  });
                }
                self.isLoadingIbanList = false;
              })
              .catch(function (err) {
                console.log(err);
                self.dropdown.listaIban = [];
                self.isLoadingIbanList = false;
              })
              .finally(function () {
                console.log("getIbanDropdown finally");
                if (
                  self.dropdown.listaIban &&
                  self.dropdown.listaIban.length > 0
                ) {
                  self.raccoltaInfo.autorizzazioneSDD.bySelect = true;
                } else {
                  self.raccoltaInfo.autorizzazioneSDD.bySelect = false;
                }
                self.loading.listaIban = false;
              });
          } else {
            $typeDomainService
              .getListIban(
                FactoryObj.selectedUserG && FactoryObj.selectedUserG.ndg
              )
              .then(function (listAppNsilIban) {
                if (listAppNsilIban && listAppNsilIban.length > 0) {
                  self.dropdown.listaIbanObj = listAppNsilIban;
                  self.dropdown.listaIban = [];
                  listAppNsilIban.forEach(function (el) {
                    self.dropdown.listaIban.push(el.iban);
                  });
                }
                self.isLoadingIbanList = false;
              })
              .catch(function (err) {
                console.log(err);
                self.dropdown.listaIban = [];
                self.isLoadingIbanList = false;
              })
              .finally(function () {
                console.log("getIbanDropdown finally");
                if (
                  self.dropdown.listaIban &&
                  self.dropdown.listaIban.length > 0
                ) {
                  self.raccoltaInfo.autorizzazioneSDD.bySelect = true;
                } else {
                  self.raccoltaInfo.autorizzazioneSDD.bySelect = false;
                }
                self.loading.listaIban = false;
              });
          }
        }
      };

      self.listBank = function () {
        $typeDomainService
          .getDomainSet("RI_DROPDOWN_DOMAINS", "BANKS")
          .then(function (response) {
            self.dropdown.listaBanche = response.domainList;
            self.selectBank();
          });
      };

      self.selectBank = function (type) {
        self.warnings.iban = false;
        self.warnings.ibanInput = false;
        var iban =
          type == "iban"
            ? self.raccoltaInfo.autorizzazioneSDD.iban
            : self.raccoltaInfo.autorizzazioneSDD.newIban;
        if (iban) {
          iban = iban.toUpperCase().trim().slice(0, 27);
          if (!self.raccoltaInfo.autorizzazioneSDD.ibanRadio) {
            self.raccoltaInfo.autorizzazioneSDD.ibanRadio = "b2b";
          }
          if (checkiban(iban)) {
            self.warnings.iban = false;
            var code = iban.slice(5, 10);
            var bank = self.dropdown.listaBanche.find(function (el) {
              return el.value == code;
            });
          } else {
            if (type == "iban") {
              self.warnings.iban = true;
            } else if (type == "newIban") {
              self.warnings.ibanInput = true;
            }
            self.ibanIsNotOk();
            return;
          }
          if (bank) {
            self.warnings.bank = false;
            self.raccoltaInfo.autorizzazioneSDD.banca = bank;
            $("#select-banca-container .select2").select2();
            self.warnings.newBank = false;

            if (!self.isPostVendita) {
              self.model.financialCustomer.metadata.autorizzazione =
                self.raccoltaInfo.autorizzazioneSDD;
              self.autorizzazione &&
                self.autorizzazione({
                  aut: self.model.financialCustomer.metadata.autorizzazione,
                });
            } else {
              self.richiestePostVendita = self.raccoltaInfo.autorizzazioneSDD;
              self.autorizzazione({
                aut: self.richiestePostVendita,
              });
            }
            if (!self.digital) {
              self.ibanIsOk();
            }
            if (
              type == "newIban" &&
              self.raccoltaInfo.autorizzazioneSDD.newIban
            ) {
              self.raccoltaInfo.autorizzazioneSDD.iban =
                self.raccoltaInfo.autorizzazioneSDD.newIban;
              $transactionFactory.set(true);
            } else if (type == "iban") {
              $transactionFactory.set(false);
            }
          } else {
            if (type == "iban") {
              self.warnings.bank = true;
            } else if (type == "newIban") {
              self.warnings.newBank = true;
              self.newBank = {
                tableName: "RI_DROPDOWN_DOMAINS",
                columnName: "BANKS",
                name: "",
                value: code,
              };
            }
            if (!self.isPostVendita) {
              self.model.financialCustomer.metadata.autorizzazione =
                self.raccoltaInfo.autorizzazioneSDD;
            } else {
              self.richiestePostVendita = self.raccoltaInfo.autorizzazioneSDD;
            }
            if (!self.digital) {
              self.ibanIsOk();
            }
            self.insertBank();
            if (
              type == "newIban" &&
              self.raccoltaInfo.autorizzazioneSDD.newIban
            ) {
              self.raccoltaInfo.autorizzazioneSDD.iban =
                self.raccoltaInfo.autorizzazioneSDD.newIban;
              $transactionFactory.set(true);
            } else if (type == "iban") {
              $transactionFactory.set(false);
            }
          }

          if (self.digital && checkiban(iban)) {
            callcheckIban(iban);
          }
        } else {
          self.raccoltaInfo.autorizzazioneSDD.banca = null;
          self.warnings.bank = false;
          self.warnings.newBank = false;
          if ($portalService.isAra() && !iban) {
            self.ibanIsOk();
            self.warnings.annulledBank = false;
          }
          if (self.isPostVendita) {
            self.autorizzazione({
              aut: self.richiestePostVendita,
            });
            self.ibanIsNotOk();
          } else if (
            !self.isPostVendita &&
            getWizardMap(self.model.viewIndex) == "M12"
          ) {
            self.isM12 = true;
            self.ibanIsOk();
          }
        }
      };

      self.insertBank = function () {
        if (self.newBank != null) {
          if (
            !!self.raccoltaInfo.autorizzazioneSDD &&
            !!self.raccoltaInfo.autorizzazioneSDD.banca &&
            !!self.raccoltaInfo.autorizzazioneSDD.banca.nome
          ) {
            self.newBank.name = self.raccoltaInfo.autorizzazioneSDD.banca.nome;
            HttpService.send("/uni/typedomain/insertDomainSet", {
              uniTypeDomain: self.newBank,
            }).then(function (response) { });
          }
        }
      };

      self.handleChange = function (name, value) {
        switch (name) {
          case "bank":
            if (
              self.raccoltaInfo.autorizzazioneSDD.banca &&
              self.raccoltaInfo.autorizzazioneSDD.banca.name
            ) {
              self.raccoltaInfo.autorizzazioneSDD.banca.name = value;
            }
            callcheckIban(self.raccoltaInfo.autorizzazioneSDD.newIban);
            break;
          case "otherBanks":
            self.raccoltaInfo.autorizzazioneSDD[name] = value;
            break;
          default:
            break;
        }
        var type =
          self.raccoltaInfo.autorizzazioneSDD &&
            self.raccoltaInfo.autorizzazioneSDD.newIban
            ? self.raccoltaInfo.autorizzazioneSDD.newIban
            : self.raccoltaInfo.autorizzazioneSDD.iban;
        self.selectBank(type);
      };

      var callcheckIban = function (iban) {
        if (iban.slice(0, 2) != "IT") {
          self.ibanIsNotOk();
          $rootScope.$broadcast("addAlert", {
            text: "LBL_CHECK_IBAN_UNKNOWN",
          });
          return;
        }
        self.warnings.annulledBank = false;
        $financialApiService
          .checkIban(iban)
          .then(function (ibanResponse) {
            if (
              ibanResponse.keyMessage == "LBL_CHECK_IBAN_UNKNOWN" ||
              ibanResponse.keyMessage == "LBL_CHECK_IBAN_ANNULLED" ||
              ibanResponse.keyMessage == "LBL_CHECK_IBAN_ERROR_ARC"
            ) {
              if ($portalService.isAra()) {
                self.warnings.annulledBank = true;
                self.ibanIsNotOk();
              } else if ($portalService.isAru()) {
                self.ibanIsOk();
              }
            } else {
              self.ibanIsOk();
              if (
                self.raccoltaInfo.autorizzazioneSDD &&
                self.raccoltaInfo.autorizzazioneSDD.newIban
              ) {
                self.raccoltaInfo.autorizzazioneSDD.iban =
                  self.raccoltaInfo.autorizzazioneSDD.newIban;
              }
            }
          })
          .catch(function (err) {
            console.log("Errore: ", err);
          });
      };

      var getWizardMap = function (viewIndex) {
        return $rootScope.wizardMap.find(function (element) {
          return element.index == viewIndex;
        }).viewName;
      };

      self.check = function () {
        self.warnings.annulledBank = false;
        if (self.addIban.selected) {
          self.raccoltaInfo.autorizzazioneSDD.newIban = "";
          self.raccoltaInfo.autorizzazioneSDD.iban = null;
          self.warnings.ibanInput = false;
          self.warnings.newBank = null;
        } else if (!self.addIban.selected) {
          self.warnings.bank = null;
          self.raccoltaInfo.autorizzazioneSDD.iban = null;
        }
        self.selectBank();
      };
    },
  });
